// extracted by mini-css-extract-plugin
module.exports = {"icon":"TabMenu_icon__1xsOW","spinner":"TabMenu_spinner__-gegB","spinnerAnimation":"TabMenu_spinnerAnimation__3ALFt"};